import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=76b52a66&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b52a66",
  null
  
)

export default component.exports